import { Directive, HostListener, Input } from '@angular/core';
import { EventTrackingService } from '../../../shared/event-tracking/event-tracking.service';
import { EventTrackingValue } from '../../../team-apis/core/event-tracking';

@Directive({
  selector: '[h3TrackAs]',
  standalone: false,
})
export class TrackAsDirective {
  @Input({ required: true }) eventId!: string;
  @Input({ required: true }) subBucket!: string;
  @Input() trackValue?: EventTrackingValue;
  @Input() trackExperiment?: string;

  constructor(private eventTracking: EventTrackingService) {}

  @HostListener('click')
  onClick() {
    this.eventTracking.track({
      id: this.eventId,
      bucket: 'navigation',
      sub_bucket: this.subBucket,
      ...this.trackValue,
    });
  }
}
